module.exports = __webpack_public_path__ + "assets/img/Rail Corridor.a52a2643.jpg";